import React from 'react';
import { useTranslation } from 'react-i18next';
import Lottie from "lottie-react";
import securityAnimation from '../assets/lottie-security.json';
import openAiLogoUrl from '../assets/logo-openai.svg';
import geminiLogoUrl from '../assets/logo-gemini.svg';
import claudeLogoUrl from '../assets/logo-claude.svg';

// Ícones (sem alterações)
const AnalysisIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 12h6M9 12h2M9 12a5 5 0 01-5-5V5" /></svg>;
const FirewallDecisionIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.57-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.286z" /></svg>;
const SecureExecutionIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path d="M9 12.75L11.25 15 15 9.75" /><path strokeLinecap="round" strokeLinejoin="round" d="M14.25 6.087c0-1.721.8-3.322 2.162-4.381.385-.304.236-.913-.243-.913H7.83c-.479 0-.629.609-.243.913C8.95 2.765 9.75 4.366 9.75 6.087v2.613a.75.75 0 00.75.75h3a.75.75 0 00.75-.75V6.087z" /><path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9 9 0 100-18 9 9 0 000 18z" /></svg>;




const HowItWorks = () => {
    const { t } = useTranslation();

    const steps = [
        { icon: <AnalysisIcon />, titleKey: 'how_step1_title', descKey: 'how_step1_desc', desktopClasses: 'md:top-0 md:left-0 md:text-left' },
        { icon: <FirewallDecisionIcon />, titleKey: 'how_step2_title', descKey: 'how_step2_desc', desktopClasses: 'md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:text-center' },
        { icon: <SecureExecutionIcon />, titleKey: 'how_step3_title', descKey: 'how_step3_desc', desktopClasses: 'md:top-full md:left-full md:-translate-y-full md:-translate-x-full md:text-right' },
    ];



    return (
        // A ÚNICA ALTERAÇÃO É AQUI: Adicionando a classe 'overflow-hidden'
        <section id="how-it-works" className="py-24 bg-blueprint-bg overflow-hidden">
            <div className="container mx-auto px-6">
                <div className="text-center mb-24">
                    <h2 className="text-4xl font-bold text-white" data-aos="fade-up">{t('how_title')}</h2>
                    <p className="text-lg text-gray-300 mt-4 max-w-3xl mx-auto" data-aos="fade-up" data-aos-delay="200">{t('how_subtitle')}</p>
                </div>

                {/* --- Layout para Desktop --- */}
                <div className="hidden md:block relative h-[500px] w-full" data-aos="fade-in">
                    <svg className="absolute top-0 left-0 w-full h-full" width="100%" height="100%" viewBox="0 0 1200 500" preserveAspectRatio="none">
                        <path d="M 50 50 Q 300 250 600 250 T 1150 450" stroke="#00BFFF" strokeOpacity="0.5" strokeWidth="4" fill="none" className="path-draw" />
                    </svg>

                    {steps.map((step, index) => (
                        <div key={index} className={`absolute w-1/3 lg:w-1/4 p-4 ${step.desktopClasses}`}>
                            <div className="absolute bg-accent text-white h-12 w-12 rounded-full flex items-center justify-center font-bold text-2xl shadow-lg shadow-accent/50 transform -translate-x-1/2 -translate-y-1/2"
                                style={{
                                    top: index === 0 ? '50px' : (index === 1 ? '250px' : '450px'),
                                    left: index === 0 ? '50px' : (index === 1 ? '600px' : '1150px')
                                }}>
                                {index + 1}
                            </div>

                            <div className="bg-white rounded-xl shadow-2xl p-6" data-aos="zoom-in-up" data-aos-delay={index * 200}>
                                <div className="flex justify-center mb-4">
                                    {step.icon}
                                </div>
                                <h3 className="text-xl font-bold text-primary mb-2 text-center">{t(step.titleKey)}</h3>
                                <p className="text-gray-600 text-center text-sm">{t(step.descKey)}</p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* --- Layout para Mobile --- */}
                <div className="md:hidden space-y-12">
                    {steps.map((step, index) => (
                        <div key={index} className="text-center" data-aos="fade-up">
                            <div className="flex justify-center mb-4">
                                <div className="text-accent">{step.icon}</div>
                            </div>
                            <h3 className="text-2xl font-bold text-white mb-2">{t(step.titleKey)}</h3>
                            <p className="text-gray-300 px-4">{t(step.descKey)}</p>
                        </div>
                    ))}
                </div>

                <div className="mt-24" data-aos="fade-up">
                    <div className="text-center">
                        <h3 className="text-3xl font-bold text-white">{t('how_compatibility_title')}</h3>
                        <p className="mt-4 text-gray-400 max-w-2xl mx-auto">{t('how_compatibility_desc')}</p>
                    </div>
                    <div className="mt-12 flex justify-center items-center space-x-12">
                        <div className="transition-all duration-300 grayscale hover:grayscale-0 hover:scale-110">
                            <img src={openAiLogoUrl} alt="OpenAI Logo" className="h-10 w-auto" />
                        </div>
                        <div className="transition-all duration-300 grayscale hover:grayscale-0 hover:scale-110">
                            <img src={geminiLogoUrl} alt="Gemini Logo" className="h-12 w-auto" />
                        </div>
                        <div className="transition-all duration-300 grayscale hover:grayscale-0 hover:scale-110">
                            <img src={claudeLogoUrl} alt="Claude Logo" className="h-8 w-auto" />
                        </div>
                    </div>
                </div>


            </div>
        </section>
    );
};

export default HowItWorks;